import React from "react";
import laptopImg from "../images/about-img.png";

const About = () =>{
    return (
        <>
            <div className="about-section">
                <div className="Wrapper">

                <div className="left-side">
                    <p className="title">A Developer, Who is developing himself to develop Greats stuff</p>
                    <h1 className="heading">About Me</h1>
                    <p className="description">
                        Software developers design, program, build, deploy and maintain software using many different skills and tools. They also 
                        help build software systems that power networks and devices and ensure that those systems remain functional.
                        A creative designer produces artwork and design concepts that can take on many different forms. For example, you might 
                        create visuals collaborative thinking to further the overall value proposition supports that argument with evidence.
                    </p>
                    <button className="btn">Read More</button>
                </div>
                <div className="right-side">
                    <img src={laptopImg} alt="img"/>
                </div>
                </div>
            </div>
        </>
    )
}
export default About;